import { getClassNames } from '@ab-core/functions/styles/classNameFormatter';
import type { InputProps } from '@ab-core/input';
import React from 'react';
import { SwitchContainer, Wrapper } from './index.styled';

export type SwitchProps = Omit<InputProps, 'value' | 'errorMessage'>;

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
    const { label, className, ...rest } = props;

    const inputClass = getClassNames({
        className,
        prefix: 'switch'
    });
    const spanClass = getClassNames({
        prefix: 'slider'
    });
    const labelClass = getClassNames({
        prefix: 'labelSlider'
    });

    return (
        <Wrapper>
            <SwitchContainer>
                <input {...rest} ref={ref} type="checkbox" className={inputClass} />
                <span className={spanClass} />
            </SwitchContainer>
            {label && <label className={labelClass}>{label}</label>}
        </Wrapper>
    );
});
